import React from 'react'

import "./databar.css"
import { chartinfo, Chart } from "./charts"

export default function Databar() {

    const charts = chartinfo.map(chart => {
        return (
          <Chart 
            key={chart.id}
            {...chart}
          />
        )
    })        
  return (
    <div className='emas__databar'>
        <div className='emas__databar-heading'>
            <h1>Western Australia Market Snapshot</h1>
        </div>
        <section className='emas__databar-charts'>
            {charts}
        </section>
    </div>
  )
}
